module.exports = __webpack_public_path__ + "img/top_slider_202504_ouencampaign2.06788d7b.jpg";